import { render } from "./ModalReconnect.vue?vue&type=template&id=061b8c84"
import script from "./ModalReconnect.vue?vue&type=script&lang=js"
export * from "./ModalReconnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__